import { colors } from '../../styles'

const borderColors = {
  default: 'none',
  primary: colors.primary.base,
  secondary: colors.log.error,
}
const Card = {
  baseStyle: {
    p: '22px',
    display: 'flex',
    flexDirection: 'column',
    // width: '100%',
    position: 'relative',
    wordWrap: 'break-word',
    backgroundClip: 'border-box',
  },
  variants: {
    indicator: {
      width: '70%',
      bg: '#FFFFFF',
      boxShadow: '4px 6px 20px rgba(0, 0, 0, 0.15)',
      borderRadius: '15px',
    },
    panel: (props) => ({
      bg: props.colorMode === 'dark' ? 'gray.700' : 'white',
      width: ['100%', '100%', '45%', '45%', null, null],
      height: props.height ? props.height : '140px',
      border: `1px solid ${borderColors[props.borderType]}`,
      boxShadow: '4px 6px 20px rgba(0, 0, 0, 0.15)',
      borderRadius: '15px',
    }),
    panelFull: (props) => ({
      bg: props.colorMode === 'dark' ? 'gray.700' : 'white',
      width: '100%',
      height: props.height ? props.height : '140px',
      border: `1px solid ${borderColors[props.borderType]}`,
      boxShadow: '4px 6px 20px rgba(0, 0, 0, 0.15)',
      borderRadius: '15px',
    }),
    chart: (props) => ({
      bg: props.colorMode === 'dark' ? 'gray.700' : 'white',
      width: ['100%', '100%', '42%', '32%', '32%', null],
      minWidth: '324px',
      height: props.height ? props.height : '291px',
      boxShadow: '4px 6px 20px rgba(0, 0, 0, 0.15)',
      borderRadius: '15px',
    }),
    'chart-empty': {
      bg: 'transparent',
      width: '200px',
      height: '291px',
    },
    'indicator-chart': (props) => ({
      bg: props.colorMode === 'dark' ? 'gray.700' : 'white',
      width: '70%',
      // minWidth: '220px',
      height: props.height ? props.height : '291px',
      boxShadow: '4px 6px 20px rgba(0, 0, 0, 0.15)',
      borderRadius: '15px',
    }),
  },
  defaultProps: {
    variant: 'panel',
  },
}

export const CardComponent = {
  ...Card,
}
